module.exports = __webpack_public_path__ + "img/angularJs.64260a38.svg";